import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
const cookie = Cookies.get("user") || null;
let userData = "";
if (cookie) {
  userData = JSON.parse(cookie);
}
export const employeeSlice = createSlice({
  name: "EmployeeReducer",
  initialState: {
    currentPage: 1,
    filters: {
      startdate: "",
      enddate: "",
      name: "",
    },
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    setReduxFilters: (state, action) => {
      state.filters = action.payload;
    },

    resetFilters: (state) => {
      state.filters = {
        startdate: "",
        enddate: "",
        name: "",
      };
    },
  },
});

export const { setCurrentPage, setReduxFilters, resetFilters } =
  employeeSlice.actions;
export default employeeSlice.reducer;
